import React from 'react';
import reactStringReplace from 'react-string-replace';

const transformDisplayText = (text, defaultFontSize, increaseFontSize) => {
  if (typeof text !== 'string' || text === '') {
    return text;
  }

  let replacedText;

  // Match Bold
  replacedText = reactStringReplace(text, /#boldstart#([\s\S]*?)#boldend#/g, (match, i) => {
    match = underlineText(match);
    return (
      <span key={match + i} style={{ fontWeight: 'bold' }}>
        {match}
      </span>
    );
  });

  // Match Underline
  replacedText = reactStringReplace(replacedText, /#underlinestart#([\s\S]*?)#underlineend#/g, (match, i) => {
    match = italicText(match);
    return (
      <span key={match + i} style={{ textDecoration: 'underline' }}>
        {match}
      </span>
    );
  });

  // Match Italic
  replacedText = reactStringReplace(replacedText, /#italicstart#([\s\S]*?)#italicend#/g, (match, i) => {
    match = redFontText(match);
    return (
      <span key={match + i} style={{ fontStyle: 'italic' }}>
        {match}
      </span>
    );
  });

  // Match Red color
  replacedText = reactStringReplace(replacedText, /#redfontstart#([\s\S]*?)#redfontend#/g, (match, i) => {
    return (
      <span key={match + i} style={{ color: '#f00' }}>
        {match}
      </span>
    );
  });

  if (defaultFontSize && increaseFontSize) {
    return (
      <span
        style={{
          fontSize: defaultFontSize + increaseFontSize,
        }}>
        {replacedText}
      </span>
    );
  }

  return replacedText;
};

const underlineText = text => {
  let returnStr = '';
  reactStringReplace(text, /#underlinestart#([\s\S]*?)#underlineend#/g, (match, i) => {
    match = italicText(match);
    returnStr = (
      <span key={match + i} style={{ textDecoration: 'underline' }}>
        {match}
      </span>
    );
  });
  return returnStr ? returnStr : italicText(text);
};

const italicText = text => {
  let returnStr = '';
  reactStringReplace(text, /#italicstart#([\s\S]*?)#italicend#/g, (match, i) => {
    match = redFontText(match);
    returnStr = (
      <span key={match + i} style={{ fontStyle: 'italic' }}>
        {match}
      </span>
    );
  });
  return returnStr ? returnStr : redFontText(text);
};

const redFontText = text =>
  reactStringReplace(text, /#redfontstart#([\s\S]*?)#redfontend#/g, (match, i) => {
    return (
      <span key={match + i} style={{ color: '#f00' }}>
        {match}
      </span>
    );
  });

export const capitalizeFirstLetter = text => {
  let lowerCaseText = '';
  if (text) {
    lowerCaseText = text.toLowerCase();
  }
  return lowerCaseText.charAt(0).toUpperCase() + lowerCaseText.slice(1);
};

export default transformDisplayText;



// WEBPACK FOOTER //
// ./src/helpers/transformDisplayText.js